// Mock data for luxury shoe brand landing page

export const products = [
  {
    id: 1,
    name: "Lumière Glitter Pumps",
    description: "Handcrafted Italian leather with rose gold embellishments",
    price: "$850",
    image: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3NjQ5OTE2MzN8MA&ixlib=rb-4.1.0&q=85",
    category: "heels"
  },
  {
    id: 2,
    name: "Étoile Stilettos",
    description: "Classic pointed-toe design in premium suede",
    price: "$695",
    image: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3NjQ5OTE2MzN8MA&ixlib=rb-4.1.0&q=85",
    category: "heels"
  },
  {
    id: 3,
    name: "Riviera Sandals",
    description: "Elegant strappy design with signature hardware",
    price: "$725",
    image: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzaG9lc3xlbnwwfHx8fDE3NjQ5OTE2MzN8MA&ixlib=rb-4.1.0&q=85",
    category: "sandals"
  },
  {
    id: 4,
    name: "Classique Court Shoes",
    description: "Timeless silhouette in buttery soft leather",
    price: "$645",
    image: "https://images.unsplash.com/photo-1535043934128-cf0b28d52f95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxoZWVsc3xlbnwwfHx8fDE3NjQ5OTE2NDl8MA&ixlib=rb-4.1.0&q=85",
    category: "heels"
  },
  {
    id: 5,
    name: "Rosette Patent Heels",
    description: "Bold statement piece in glossy patent leather",
    price: "$795",
    image: "https://images.unsplash.com/photo-1573100925118-870b8efc799d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxoZWVsc3xlbnwwfHx8fDE3NjQ5OTE2NDl8MA&ixlib=rb-4.1.0&q=85",
    category: "heels"
  },
  {
    id: 6,
    name: "Montmartre Ankle Boots",
    description: "Refined lace-up boots with architectural heel",
    price: "$925",
    image: "https://images.unsplash.com/photo-1610398752800-146f269dfcc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxoZWVsc3xlbnwwfHx8fDE3NjQ5OTE2NDl8MA&ixlib=rb-4.1.0&q=85",
    category: "boots"
  },
  {
    id: 7,
    name: "Élégance Evening Pumps",
    description: "Sophisticated design perfect for special occasions",
    price: "$765",
    image: "https://images.pexels.com/photos/1630344/pexels-photo-1630344.jpeg",
    category: "heels"
  },
  {
    id: 8,
    name: "Chic Moderne Heels",
    description: "Contemporary styling with traditional craftsmanship",
    price: "$685",
    image: "https://images.pexels.com/photos/3782786/pexels-photo-3782786.jpeg",
    category: "heels"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Isabella Laurent",
    role: "Fashion Editor",
    content: "The quality and craftsmanship are exceptional. Each pair is a work of art that elevates every outfit.",
    rating: 5
  },
  {
    id: 2,
    name: "Sofia Chen",
    role: "Style Consultant",
    content: "Unparalleled comfort meets luxury design. These shoes are an investment in both style and quality.",
    rating: 5
  },
  {
    id: 3,
    name: "Emma Rousseau",
    role: "Brand Director",
    content: "The attention to detail is remarkable. From the packaging to the final product, everything exudes luxury.",
    rating: 5
  },
  {
    id: 4,
    name: "Olivia Martinez",
    role: "Entrepreneur",
    content: "I've collected five pairs now. The perfect blend of elegance, comfort, and timeless design.",
    rating: 5
  },
  {
    id: 5,
    name: "Amelia Thompson",
    role: "Creative Director",
    content: "These shoes are more than accessories—they're statements. Absolutely love the craftsmanship.",
    rating: 5
  }
];

export const sizeGuide = [
  { us: "5", eu: "35", uk: "2.5", cm: "22" },
  { us: "5.5", eu: "35.5", uk: "3", cm: "22.5" },
  { us: "6", eu: "36", uk: "3.5", cm: "23" },
  { us: "6.5", eu: "37", uk: "4", cm: "23.5" },
  { us: "7", eu: "37.5", uk: "4.5", cm: "24" },
  { us: "7.5", eu: "38", uk: "5", cm: "24.5" },
  { us: "8", eu: "38.5", uk: "5.5", cm: "25" },
  { us: "8.5", eu: "39", uk: "6", cm: "25.5" },
  { us: "9", eu: "39.5", uk: "6.5", cm: "26" },
  { us: "9.5", eu: "40", uk: "7", cm: "26.5" },
  { us: "10", eu: "41", uk: "7.5", cm: "27" },
  { us: "10.5", eu: "41.5", uk: "8", cm: "27.5" },
  { us: "11", eu: "42", uk: "8.5", cm: "28" }
];

export const chatMessages = [
  {
    id: 1,
    sender: "bot",
    message: "Welcome to SOLENNE. How may I assist you today?",
    timestamp: new Date().toISOString()
  }
];
